import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container pdf_area_class" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "area_button"
}
const _hoisted_6 = { class: "area_body" }
const _hoisted_7 = { class: "area_section" }
const _hoisted_8 = { class: "area_form" }
const _hoisted_9 = { class: "area_form_body" }
const _hoisted_10 = { class: "area_row" }
const _hoisted_11 = { class: "area_col_body" }
const _hoisted_12 = { class: "datepicker" }
const _hoisted_13 = ["value", "disabled"]
const _hoisted_14 = { class: "area_row" }
const _hoisted_15 = { class: "area_col_body" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "area_row" }
const _hoisted_19 = { class: "area_col_body" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "area_row" }
const _hoisted_23 = { class: "area_col_body" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "area_row" }
const _hoisted_27 = { class: "area_col_body" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { class: "area_row" }
const _hoisted_31 = { class: "area_col_body full" }
const _hoisted_32 = { class: "flex ac" }
const _hoisted_33 = { class: "select-wrap" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "full" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "area_row" }
const _hoisted_39 = { class: "area_col_body full" }
const _hoisted_40 = { class: "flex ac" }
const _hoisted_41 = { class: "select-wrap" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "full" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "area_row" }
const _hoisted_47 = { class: "area_col_body full" }
const _hoisted_48 = { class: "flex ac" }
const _hoisted_49 = { class: "select-wrap" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "full" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "area_row" }
const _hoisted_55 = { class: "area_col_body" }
const _hoisted_56 = { class: "select-wrap" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "area_form_foot" }
const _hoisted_60 = { class: "area_button" }
const _hoisted_61 = {
  key: 0,
  class: "area_comment"
}
const _hoisted_62 = { class: "container pdf_area_class" }
const _hoisted_63 = { class: "area_body" }
const _hoisted_64 = { class: "area_section" }
const _hoisted_65 = { class: "area_form" }
const _hoisted_66 = { class: "area_form_body" }
const _hoisted_67 = { class: "area_row" }
const _hoisted_68 = { class: "area_col_row" }
const _hoisted_69 = {
  class: "area_col",
  style: {"justify-content":"center"}
}
const _hoisted_70 = { class: "area_col_body" }
const _hoisted_71 = { class: "radio_wrap" }
const _hoisted_72 = ["checked", "disabled"]
const _hoisted_73 = ["checked", "disabled"]
const _hoisted_74 = ["checked", "disabled"]
const _hoisted_75 = {
  key: 0,
  class: "area_col"
}
const _hoisted_76 = { class: "area_col_body" }
const _hoisted_77 = { class: "radio_wrap" }
const _hoisted_78 = ["checked", "disabled"]
const _hoisted_79 = ["checked", "disabled"]
const _hoisted_80 = ["checked", "disabled"]
const _hoisted_81 = ["checked", "disabled"]
const _hoisted_82 = ["checked", "disabled"]
const _hoisted_83 = { class: "container pdf_area_class" }
const _hoisted_84 = { class: "area_body" }
const _hoisted_85 = { class: "area_section" }
const _hoisted_86 = { class: "area_form" }
const _hoisted_87 = { class: "area_form_body" }
const _hoisted_88 = { class: "area_row" }
const _hoisted_89 = { class: "area_col_body" }
const _hoisted_90 = { class: "radio_wrap" }
const _hoisted_91 = ["checked", "disabled"]
const _hoisted_92 = ["checked", "disabled"]
const _hoisted_93 = ["checked", "disabled"]
const _hoisted_94 = { class: "area_row" }
const _hoisted_95 = { class: "area_col_body" }
const _hoisted_96 = { class: "flex ac" }
const _hoisted_97 = { class: "" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = { class: "" }
const _hoisted_100 = ["disabled"]
const _hoisted_101 = { class: "flex ac" }
const _hoisted_102 = { class: "" }
const _hoisted_103 = { class: "flex ac" }
const _hoisted_104 = { class: "checkbox_wrap flex ac" }
const _hoisted_105 = ["checked", "disabled"]
const _hoisted_106 = { class: "" }
const _hoisted_107 = ["disabled"]
const _hoisted_108 = { class: "area_row" }
const _hoisted_109 = { class: "area_col_row" }
const _hoisted_110 = { class: "area_col" }
const _hoisted_111 = { class: "area_col_body full" }
const _hoisted_112 = { class: "" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = { class: "area_col" }
const _hoisted_115 = { class: "area_col_body full" }
const _hoisted_116 = { class: "" }
const _hoisted_117 = ["disabled"]
const _hoisted_118 = { class: "area_row" }
const _hoisted_119 = { class: "area_col_row" }
const _hoisted_120 = { class: "area_col" }
const _hoisted_121 = { class: "area_col_body full" }
const _hoisted_122 = { class: "" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { class: "area_col" }
const _hoisted_125 = { class: "area_col_body" }
const _hoisted_126 = { class: "" }
const _hoisted_127 = ["disabled"]
const _hoisted_128 = { class: "area_row" }
const _hoisted_129 = { class: "area_col_body" }
const _hoisted_130 = { class: "flex ac ph_input_box" }
const _hoisted_131 = { class: "ph_input" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = { class: "ph_input" }
const _hoisted_134 = ["disabled"]
const _hoisted_135 = { class: "ph_input" }
const _hoisted_136 = ["disabled"]
const _hoisted_137 = { class: "flex ac" }
const _hoisted_138 = { class: "" }
const _hoisted_139 = ["disabled"]
const _hoisted_140 = { class: "flex ac" }
const _hoisted_141 = { class: "" }
const _hoisted_142 = ["disabled"]
const _hoisted_143 = { class: "area_row" }
const _hoisted_144 = { class: "area_col_body" }
const _hoisted_145 = { class: "flex ac ph_input_box" }
const _hoisted_146 = { class: "ph_input" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = { class: "ph_input" }
const _hoisted_149 = ["disabled"]
const _hoisted_150 = { class: "ph_input" }
const _hoisted_151 = ["disabled"]
const _hoisted_152 = { class: "flex ac" }
const _hoisted_153 = { class: "" }
const _hoisted_154 = ["disabled"]
const _hoisted_155 = { class: "flex ac" }
const _hoisted_156 = { class: "" }
const _hoisted_157 = ["disabled"]
const _hoisted_158 = { class: "area_row" }
const _hoisted_159 = { class: "area_col_body" }
const _hoisted_160 = { class: "flex ac ph_input_box" }
const _hoisted_161 = { class: "ph_input" }
const _hoisted_162 = ["disabled"]
const _hoisted_163 = { class: "ph_input" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = { class: "ph_input" }
const _hoisted_166 = ["disabled"]
const _hoisted_167 = { class: "flex ac" }
const _hoisted_168 = { class: "" }
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "flex ac" }
const _hoisted_171 = { class: "" }
const _hoisted_172 = ["disabled"]
const _hoisted_173 = { class: "area_row" }
const _hoisted_174 = { class: "area_col_body" }
const _hoisted_175 = { class: "full" }
const _hoisted_176 = ["disabled"]
const _hoisted_177 = { class: "area_row page_avoid" }
const _hoisted_178 = { class: "area_col_row" }
const _hoisted_179 = { class: "area_col no-line-bottom" }
const _hoisted_180 = { class: "area_col_body" }
const _hoisted_181 = { class: "flex ac" }
const _hoisted_182 = { class: "" }
const _hoisted_183 = ["disabled"]
const _hoisted_184 = ["value"]
const _hoisted_185 = {
  key: 0,
  class: ""
}
const _hoisted_186 = ["disabled"]
const _hoisted_187 = ["value"]
const _hoisted_188 = {
  key: 1,
  class: ""
}
const _hoisted_189 = ["disabled"]
const _hoisted_190 = ["value"]
const _hoisted_191 = {
  key: 2,
  class: ""
}
const _hoisted_192 = ["disabled"]
const _hoisted_193 = ["value"]
const _hoisted_194 = { class: "area_col" }
const _hoisted_195 = { class: "area_col_body textarea_wrap" }
const _hoisted_196 = ["disabled"]
const _hoisted_197 = ["textContent"]
const _hoisted_198 = { class: "area_row" }
const _hoisted_199 = { class: "area_col_row" }
const _hoisted_200 = { class: "area_col no-line-bottom" }
const _hoisted_201 = { class: "area_col_body" }
const _hoisted_202 = { class: "" }
const _hoisted_203 = ["disabled"]
const _hoisted_204 = ["value"]
const _hoisted_205 = { class: "area_col" }
const _hoisted_206 = { class: "area_col_body textarea_wrap" }
const _hoisted_207 = ["disabled"]
const _hoisted_208 = ["textContent"]
const _hoisted_209 = { class: "area_row" }
const _hoisted_210 = { class: "area_col_row" }
const _hoisted_211 = { class: "area_col no-line-bottom" }
const _hoisted_212 = { class: "area_col_body" }
const _hoisted_213 = { class: "" }
const _hoisted_214 = ["disabled"]
const _hoisted_215 = ["value"]
const _hoisted_216 = { class: "area_col" }
const _hoisted_217 = { class: "area_col_body textarea_wrap" }
const _hoisted_218 = ["disabled"]
const _hoisted_219 = ["textContent"]
const _hoisted_220 = { class: "area_row" }
const _hoisted_221 = { class: "area_col_row" }
const _hoisted_222 = { class: "area_col no-line-bottom" }
const _hoisted_223 = { class: "area_col_body" }
const _hoisted_224 = { class: "" }
const _hoisted_225 = ["disabled"]
const _hoisted_226 = ["value"]
const _hoisted_227 = { class: "area_col" }
const _hoisted_228 = { class: "area_col_body textarea_wrap" }
const _hoisted_229 = ["disabled"]
const _hoisted_230 = ["textContent"]
const _hoisted_231 = { class: "area_row" }
const _hoisted_232 = { class: "area_col_body" }
const _hoisted_233 = { class: "flex ac" }
const _hoisted_234 = { class: "" }
const _hoisted_235 = ["disabled"]
const _hoisted_236 = { class: "flex ac" }
const _hoisted_237 = { class: "" }
const _hoisted_238 = ["disabled"]
const _hoisted_239 = { class: "area_row" }
const _hoisted_240 = { class: "area_col_body" }
const _hoisted_241 = { class: "radio_wrap" }
const _hoisted_242 = ["checked", "disabled"]
const _hoisted_243 = ["checked", "disabled"]
const _hoisted_244 = ["checked", "disabled"]
const _hoisted_245 = { class: "full" }
const _hoisted_246 = ["disabled"]
const _hoisted_247 = { class: "area_row" }
const _hoisted_248 = { class: "area_col_row" }
const _hoisted_249 = { class: "area_col" }
const _hoisted_250 = { class: "area_col_body" }
const _hoisted_251 = { class: "radio_wrap" }
const _hoisted_252 = ["checked", "disabled"]
const _hoisted_253 = ["checked", "disabled"]
const _hoisted_254 = { class: "area_col" }
const _hoisted_255 = { class: "area_col_body" }
const _hoisted_256 = { class: "radio_wrap" }
const _hoisted_257 = ["checked", "disabled"]
const _hoisted_258 = ["checked", "disabled"]
const _hoisted_259 = ["checked", "disabled"]
const _hoisted_260 = { class: "area_col" }
const _hoisted_261 = { class: "area_col_body" }
const _hoisted_262 = { class: "radio_wrap" }
const _hoisted_263 = ["checked", "disabled"]
const _hoisted_264 = ["checked", "disabled"]
const _hoisted_265 = ["checked", "disabled"]
const _hoisted_266 = { class: "area_row" }
const _hoisted_267 = { class: "area_col_body" }
const _hoisted_268 = { class: "radio_wrap" }
const _hoisted_269 = ["checked", "disabled"]
const _hoisted_270 = ["checked", "disabled"]
const _hoisted_271 = ["checked", "disabled"]
const _hoisted_272 = { class: "area_row" }
const _hoisted_273 = { class: "area_col_body full" }
const _hoisted_274 = { class: "flex ac" }
const _hoisted_275 = { class: "select-wrap" }
const _hoisted_276 = ["disabled"]
const _hoisted_277 = ["value"]
const _hoisted_278 = { class: "full" }
const _hoisted_279 = ["disabled"]
const _hoisted_280 = { class: "area_row" }
const _hoisted_281 = { class: "area_col_body" }
const _hoisted_282 = { class: "radio_wrap" }
const _hoisted_283 = ["checked", "disabled"]
const _hoisted_284 = ["checked", "disabled"]
const _hoisted_285 = ["checked", "disabled"]
const _hoisted_286 = { class: "full" }
const _hoisted_287 = ["disabled"]
const _hoisted_288 = { class: "area_row" }
const _hoisted_289 = { class: "area_col_row" }
const _hoisted_290 = { class: "area_col" }
const _hoisted_291 = { class: "area_col_body" }
const _hoisted_292 = { class: "radio_wrap" }
const _hoisted_293 = ["checked", "disabled"]
const _hoisted_294 = ["checked", "disabled"]
const _hoisted_295 = ["checked", "disabled"]
const _hoisted_296 = ["checked", "disabled"]
const _hoisted_297 = ["checked", "disabled"]
const _hoisted_298 = { class: "area_col" }
const _hoisted_299 = { class: "area_col_body" }
const _hoisted_300 = { class: "flex ac" }
const _hoisted_301 = { class: "" }
const _hoisted_302 = ["disabled"]
const _hoisted_303 = { class: "flex ac" }
const _hoisted_304 = { class: "" }
const _hoisted_305 = ["disabled"]
const _hoisted_306 = { class: "area_row" }
const _hoisted_307 = { class: "area_col_body" }
const _hoisted_308 = { class: "radio_wrap" }
const _hoisted_309 = ["checked", "disabled"]
const _hoisted_310 = ["checked", "disabled"]
const _hoisted_311 = ["checked", "disabled"]
const _hoisted_312 = { class: "flex ac" }
const _hoisted_313 = ["disabled"]
const _hoisted_314 = { class: "area_row" }
const _hoisted_315 = { class: "area_col_body" }
const _hoisted_316 = { class: "radio_wrap" }
const _hoisted_317 = ["checked", "disabled"]
const _hoisted_318 = ["checked", "disabled"]
const _hoisted_319 = ["checked", "disabled"]
const _hoisted_320 = ["checked", "disabled"]
const _hoisted_321 = ["checked", "disabled"]
const _hoisted_322 = ["checked", "disabled"]
const _hoisted_323 = { class: "area_row" }
const _hoisted_324 = { class: "area_col_body" }
const _hoisted_325 = { class: "radio_wrap" }
const _hoisted_326 = ["checked", "disabled"]
const _hoisted_327 = ["checked", "disabled"]
const _hoisted_328 = ["checked", "disabled"]
const _hoisted_329 = { class: "full" }
const _hoisted_330 = ["disabled"]
const _hoisted_331 = { class: "area_row" }
const _hoisted_332 = { class: "area_col_body" }
const _hoisted_333 = { class: "full" }
const _hoisted_334 = ["disabled"]
const _hoisted_335 = { class: "area_row" }
const _hoisted_336 = { class: "area_col_body" }
const _hoisted_337 = { class: "full" }
const _hoisted_338 = ["disabled"]
const _hoisted_339 = { class: "area_row" }
const _hoisted_340 = { class: "area_col_body" }
const _hoisted_341 = { class: "textarea_wrap" }
const _hoisted_342 = ["disabled"]
const _hoisted_343 = ["textContent"]
const _hoisted_344 = { class: "area_row" }
const _hoisted_345 = { class: "area_col_body no_padding" }
const _hoisted_346 = { class: "area_col_row" }
const _hoisted_347 = { class: "area_row" }
const _hoisted_348 = { class: "area_col_body" }
const _hoisted_349 = { class: "textarea_wrap" }
const _hoisted_350 = ["disabled"]
const _hoisted_351 = ["textContent"]
const _hoisted_352 = { class: "area_row" }
const _hoisted_353 = { class: "area_col_body" }
const _hoisted_354 = { class: "textarea_wrap" }
const _hoisted_355 = ["disabled"]
const _hoisted_356 = ["textContent"]
const _hoisted_357 = { class: "area_row" }
const _hoisted_358 = { class: "area_col_body" }
const _hoisted_359 = { class: "textarea_wrap" }
const _hoisted_360 = ["disabled"]
const _hoisted_361 = ["textContent"]
const _hoisted_362 = { class: "area_row" }
const _hoisted_363 = { class: "area_col_body" }
const _hoisted_364 = { class: "textarea_wrap" }
const _hoisted_365 = ["disabled"]
const _hoisted_366 = ["textContent"]
const _hoisted_367 = { class: "area_row" }
const _hoisted_368 = { class: "area_col_body" }
const _hoisted_369 = { class: "textarea_wrap" }
const _hoisted_370 = ["disabled"]
const _hoisted_371 = ["textContent"]
const _hoisted_372 = { class: "area_row" }
const _hoisted_373 = { class: "area_col_body" }
const _hoisted_374 = { class: "textarea_wrap" }
const _hoisted_375 = ["disabled"]
const _hoisted_376 = ["textContent"]
const _hoisted_377 = { class: "area_row" }
const _hoisted_378 = { class: "area_col_body" }
const _hoisted_379 = { class: "full" }
const _hoisted_380 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.state.mode)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "신규 상담"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "내담자 상세")),
          (!$setup.state.mode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.window.print()))
                }, _cache[149] || (_cache[149] = [
                  _createElementVNode("img", { src: "img/print.png" }, null, -1),
                  _createElementVNode("span", null, "PDF 출력", -1)
                ])),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'supportCard', params: { id: $setup.state.idx } })))
                }, _cache[150] || (_cache[150] = [
                  _createElementVNode("span", null, "개별지원 통합카드", -1)
                ])),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push({ name: 'counselListForClient', params: { id: $setup.state.data.idx } })))
                }, _cache[151] || (_cache[151] = [
                  _createElementVNode("span", null, "상담기록 확인", -1)
                ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[162] || (_cache[162] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "필수 입력 사항")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[152] || (_cache[152] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "초기 상담일")
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("input", {
                        type: "date",
                        ref: "strDate",
                        value: $setup.state.data.strDate,
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onChangeDate && $setup.onChangeDate(...args))),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 40, _hoisted_13)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[153] || (_cache[153] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "내담자 이름")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "w250",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.data.name) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_17), [
                        [_vModelText, $setup.state.data.name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[154] || (_cache[154] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "초기 상담원")
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "w250",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.writer) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_21), [
                        [_vModelText, $setup.state.data.writer]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[155] || (_cache[155] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "담당 상담원")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "w250",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.data.counselor) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_25), [
                        [_vModelText, $setup.state.data.counselor]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[156] || (_cache[156] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "연번")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.data.number)
                      }, null, 8, _hoisted_29)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[157] || (_cache[157] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "초기 상담 유형")
                  ], -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.data.counselType) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          class: "w250"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.key
                            }, _toDisplayString(item.name), 9, _hoisted_35))
                          }), 256))
                        ], 8, _hoisted_34), [
                          [_vModelSelect, $setup.state.data.counselType]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.data.counselComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_37), [
                          [_vModelText, $setup.state.data.counselComment]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[158] || (_cache[158] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "기관인지 경로")
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.data.location) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          class: "w250"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.locationList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.key
                            }, _toDisplayString(item.name), 9, _hoisted_43))
                          }), 256))
                        ], 8, _hoisted_42), [
                          [_vModelSelect, $setup.state.data.location]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.data.locationComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_45), [
                          [_vModelText, $setup.state.data.locationComment]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[159] || (_cache[159] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "상담 의뢰인")
                  ], -1)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.data.introducer) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          class: "w250"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.introducerList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.name
                            }, _toDisplayString(item.name), 9, _hoisted_51))
                          }), 256))
                        ], 8, _hoisted_50), [
                          [_vModelSelect, $setup.state.data.introducer]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.data.introducerComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_53), [
                          [_vModelText, $setup.state.data.introducerComment]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _cache[160] || (_cache[160] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "상담 부서")
                  ], -1)),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("select", {
                        class: "w250",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.data.dept) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (
                                                $setup.state.data.consultDepartment =
                                                    $setup.CommonOptions.deptList.find((r) => r.key === $setup.state.data.dept)?.name ?? ''
                                            ))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.deptList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.key
                          }, _toDisplayString(item.name), 9, _hoisted_58))
                        }), 256))
                      ], 40, _hoisted_57), [
                        [_vModelSelect, $setup.state.data.dept]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  ($setup.state.mode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.add('counsel')))
                        }, "등록 후 상담 기록으로 가기"),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.add('client')))
                        }, "등록 후 내담자 기록으로 가기"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "active",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.add()))
                        }, "등록")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        ($setup.state.hasAuth === 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.confirmModify('counselListForClient')))
                              }, "저장 후 상담 기록으로 가기"),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.confirmModify('client')))
                              }, "저장 후 내담자 기록으로 가기"),
                              _createElementVNode("button", {
                                type: "button",
                                class: "active",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.confirmModify()))
                              }, "저장")
                            ], 64))
                          : ($setup.state.hasAuth === -1 || $setup.state.hasAuth === 3)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "active",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.showRequestAccessModal(1)))
                              }, " 수정 권한 요청 "))
                            : ($setup.state.hasAuth === 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  type: "button",
                                  class: "gray",
                                  onClick: _cache[22] || (_cache[22] = () => {})
                                }, "수정 승인 대기"))
                              : ($setup.state.hasAuth === 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "gray",
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.showRequestAccessModal(1)))
                                    }, "수정 재승인 요청"),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "blueBtn",
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.showRejectReason($setup.state.modify.rejectReason)))
                                    }, "반려 사유")
                                  ], 64))
                                : _createCommentVNode("", true),
                        ($setup.state.hasDeleteAuth === 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              type: "button",
                              class: "danger",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.confirmRemove()))
                            }, "삭제"))
                          : ($setup.state.hasDeleteAuth === -1 || $setup.state.hasDeleteAuth === 3)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 5,
                                type: "button",
                                class: "danger",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.showRequestAccessModal(2)))
                              }, " 삭제 권한 요청 "))
                            : ($setup.state.hasDeleteAuth === 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 6,
                                  type: "button",
                                  class: "gray",
                                  onClick: _cache[27] || (_cache[27] = () => {})
                                }, "삭제 승인 대기"))
                              : ($setup.state.hasDeleteAuth === 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "gray",
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.showRequestAccessModal(2)))
                                    }, "삭제 재승인 요청"),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "blueBtn",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.showRejectReason($setup.state.remove.rejectReason)))
                                    }, "반려 사유")
                                  ], 64))
                                : _createCommentVNode("", true)
                      ], 64)),
                  ($setup.state.data.isCheck !== 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (!$setup.state.mode && $setup.CommonUtils.checkAuth())
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "active",
                              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => ($setup.confirmModify2 && $setup.confirmModify2(...args)))
                            }, " 승인 "))
                          : _createCommentVNode("", true),
                        (!$setup.state.mode && $setup.CommonUtils.checkAuth())
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "active",
                              onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => ($setup.confirmModify3 && $setup.confirmModify3(...args)))
                            }, " 보완 "))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                ($setup.state.data.isCheck !== 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.state.data.commentForTeamLeader)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _cache[161] || (_cache[161] = _createElementVNode("label", null, "팀장 보완 요청", -1)),
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.state.data.commentForTeamLeader) = $event)),
                                disabled: "",
                                style: {"width":"100%","height":"150px"}
                              }, null, 512), [
                                [_vModelText, $setup.state.data.commentForTeamLeader]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_62, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _cache[180] || (_cache[180] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "진행상황")
              ], -1)),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[179] || (_cache[179] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "진행상황")
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "state",
                              checked: $setup.state.data.state === 1,
                              onClick: _cache[33] || (_cache[33] = ($event: any) => ($setup.state.data.state = 1)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_72),
                            _cache[163] || (_cache[163] = _createElementVNode("em", null, null, -1)),
                            _cache[164] || (_cache[164] = _createElementVNode("span", null, "진행", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "state",
                              checked: $setup.state.data.state === 3,
                              onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.state.data.state = 3)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_73),
                            _cache[165] || (_cache[165] = _createElementVNode("em", null, null, -1)),
                            _cache[166] || (_cache[166] = _createElementVNode("span", null, "보류", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "state",
                              checked: $setup.state.data.state === 2,
                              onClick: _cache[35] || (_cache[35] = ($event: any) => ($setup.state.data.state = 2)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_74),
                            _cache[167] || (_cache[167] = _createElementVNode("em", null, null, -1)),
                            _cache[168] || (_cache[168] = _createElementVNode("span", null, "종결", -1))
                          ])
                        ])
                      ])
                    ]),
                    ($setup.state.data.state === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("label", null, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  name: "stateSub",
                                  checked: 
                                                            $setup.state.data.stateSub === null || $setup.state.data.stateSub === '-' || $setup.state.data.stateSub === ''
                                                        ,
                                  onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.state.data.stateSub = '')),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, null, 8, _hoisted_78),
                                _cache[169] || (_cache[169] = _createElementVNode("em", null, null, -1)),
                                _cache[170] || (_cache[170] = _createElementVNode("span", null, "해당없음", -1))
                              ]),
                              _createElementVNode("label", null, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  name: "stateSub",
                                  checked: $setup.state.data.stateSub === '긴급',
                                  onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.state.data.stateSub = '긴급')),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, null, 8, _hoisted_79),
                                _cache[171] || (_cache[171] = _createElementVNode("em", null, null, -1)),
                                _cache[172] || (_cache[172] = _createElementVNode("span", null, "긴급", -1))
                              ]),
                              _createElementVNode("label", null, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  name: "stateSub",
                                  checked: $setup.state.data.stateSub === '집중',
                                  onClick: _cache[38] || (_cache[38] = ($event: any) => ($setup.state.data.stateSub = '집중')),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, null, 8, _hoisted_80),
                                _cache[173] || (_cache[173] = _createElementVNode("em", null, null, -1)),
                                _cache[174] || (_cache[174] = _createElementVNode("span", null, "집중", -1))
                              ]),
                              _createElementVNode("label", null, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  name: "stateSub",
                                  checked: $setup.state.data.stateSub === '유지',
                                  onClick: _cache[39] || (_cache[39] = ($event: any) => ($setup.state.data.stateSub = '유지')),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, null, 8, _hoisted_81),
                                _cache[175] || (_cache[175] = _createElementVNode("em", null, null, -1)),
                                _cache[176] || (_cache[176] = _createElementVNode("span", null, "유지", -1))
                              ]),
                              _createElementVNode("label", null, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  name: "stateSub",
                                  checked: $setup.state.data.stateSub === '모니터링',
                                  onClick: _cache[40] || (_cache[40] = ($event: any) => ($setup.state.data.stateSub = '모니터링')),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, null, 8, _hoisted_82),
                                _cache[177] || (_cache[177] = _createElementVNode("em", null, null, -1)),
                                _cache[178] || (_cache[178] = _createElementVNode("span", null, "모니터링", -1))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_83, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _cache[320] || (_cache[320] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "기초자료")
              ], -1)),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _cache[187] || (_cache[187] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "성별")
                  ], -1)),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "sex",
                          checked: $setup.state.data.clientDetailVO.sex === '' || $setup.state.data.clientDetailVO.sex === null,
                          onClick: _cache[41] || (_cache[41] = ($event: any) => ($setup.state.data.clientDetailVO.sex = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_91),
                        _cache[181] || (_cache[181] = _createElementVNode("em", null, null, -1)),
                        _cache[182] || (_cache[182] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "sex",
                          checked: $setup.state.data.clientDetailVO.sex === '여',
                          onClick: _cache[42] || (_cache[42] = ($event: any) => ($setup.state.data.clientDetailVO.sex = '여')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_92),
                        _cache[183] || (_cache[183] = _createElementVNode("em", null, null, -1)),
                        _cache[184] || (_cache[184] = _createElementVNode("span", null, "여", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "sex",
                          checked: $setup.state.data.clientDetailVO.sex === '남',
                          onClick: _cache[43] || (_cache[43] = ($event: any) => ($setup.state.data.clientDetailVO.sex = '남')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_93),
                        _cache[185] || (_cache[185] = _createElementVNode("em", null, null, -1)),
                        _cache[186] || (_cache[186] = _createElementVNode("span", null, "남", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _cache[193] || (_cache[193] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "주민등록번호")
                  ], -1)),
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _withDirectives(_createElementVNode("input", {
                          class: "ss_input",
                          placeholder: "주민번호 앞자리",
                          type: "text",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.state.data.clientDetailVO.jumin1) = $event)),
                          onChange: _cache[45] || (_cache[45] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.jumin =
                                                        ($setup.state.data.clientDetailVO.jumin1 ?? '') + '-' + ($setup.state.data.clientDetailVO.jumin2 ?? '')
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "6"
                        }, null, 40, _hoisted_98), [
                          [_vModelText, $setup.state.data.clientDetailVO.jumin1]
                        ])
                      ]),
                      _cache[188] || (_cache[188] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_99, [
                        _withDirectives(_createElementVNode("input", {
                          class: "ss_input",
                          placeholder: "주민번호 뒷자리",
                          type: "text",
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.state.data.clientDetailVO.jumin2) = $event)),
                          onChange: _cache[47] || (_cache[47] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.jumin =
                                                        ($setup.state.data.clientDetailVO.jumin1 ?? '') + '-' + ($setup.state.data.clientDetailVO.jumin2 ?? '')
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "7"
                        }, null, 40, _hoisted_100), [
                          [_vModelText, $setup.state.data.clientDetailVO.jumin2]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _cache[190] || (_cache[190] = _createElementVNode("label", null, "만 나이", -1)),
                      _createElementVNode("div", _hoisted_102, [
                        _withDirectives(_createElementVNode("input", {
                          class: "old_input",
                          type: "text",
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.state.data.ageKor) = $event)),
                          readonly: true
                        }, null, 512), [
                          [_vModelText, $setup.state.data.ageKor]
                        ]),
                        _cache[189] || (_cache[189] = _createTextVNode(" 세 ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("label", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: $setup.state.data.foreigner === 'Y',
                            onClick: _cache[49] || (_cache[49] = ($event: any) => (
                                                        $setup.state.data.foreigner === 'Y' ? ($setup.state.data.foreigner = 'N') : ($setup.state.data.foreigner = 'Y')
                                                    )),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, null, 8, _hoisted_105),
                          _cache[191] || (_cache[191] = _createElementVNode("em", null, null, -1)),
                          _cache[192] || (_cache[192] = _createElementVNode("span", null, "외국인", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "국적",
                          type: "text",
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.state.data.foreignerDesc) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_107), [
                          [_vModelText, $setup.state.data.foreignerDesc]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _cache[196] || (_cache[196] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "주소")
                  ], -1)),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _cache[194] || (_cache[194] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "주민등록 상황")
                      ], -1)),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "텍스트를 입력해주세요",
                            type: "text",
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.state.data.clientDetailVO.juminAddress) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, null, 8, _hoisted_113), [
                            [_vModelText, $setup.state.data.clientDetailVO.juminAddress]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _cache[195] || (_cache[195] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "실거주지/ 주거상황")
                      ], -1)),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "텍스트를 입력해주세요",
                            type: "text",
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.state.data.clientDetailVO.address) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, null, 8, _hoisted_117), [
                            [_vModelText, $setup.state.data.clientDetailVO.address]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_118, [
                  _cache[199] || (_cache[199] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "현 주거사항")
                  ], -1)),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _cache[197] || (_cache[197] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "주거형태")
                      ], -1)),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("div", _hoisted_122, [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "텍스트를 입력해주세요",
                            type: "text",
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (($setup.state.data.clientDetailVO.addressCurrent) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, null, 8, _hoisted_123), [
                            [_vModelText, $setup.state.data.clientDetailVO.addressCurrent]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _cache[198] || (_cache[198] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "동거인")
                      ], -1)),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "텍스트를 입력해주세요",
                            type: "text",
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (($setup.state.data.clientDetailVO.roommate) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, null, 8, _hoisted_127), [
                            [_vModelText, $setup.state.data.clientDetailVO.roommate]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_128, [
                  _cache[204] || (_cache[204] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "연락처")
                  ], -1)),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _createElementVNode("div", _hoisted_131, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (($setup.state.data.clientDetailVO.phone1) = $event)),
                          onChange: _cache[56] || (_cache[56] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.phone =
                                                        $setup.state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "3"
                        }, null, 40, _hoisted_132), [
                          [_vModelText, $setup.state.data.clientDetailVO.phone1]
                        ])
                      ]),
                      _cache[200] || (_cache[200] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_133, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($setup.state.data.clientDetailVO.phone2) = $event)),
                          onChange: _cache[58] || (_cache[58] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.phone =
                                                        $setup.state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_134), [
                          [_vModelText, $setup.state.data.clientDetailVO.phone2]
                        ])
                      ]),
                      _cache[201] || (_cache[201] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_135, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (($setup.state.data.clientDetailVO.phone3) = $event)),
                          onChange: _cache[60] || (_cache[60] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.phone =
                                                        $setup.state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.phone3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_136), [
                          [_vModelText, $setup.state.data.clientDetailVO.phone3]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                      _cache[202] || (_cache[202] = _createElementVNode("label", null, "명의", -1)),
                      _createElementVNode("div", _hoisted_138, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (($setup.state.data.clientDetailVO.phoneName) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_139), [
                          [_vModelText, $setup.state.data.clientDetailVO.phoneName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _cache[203] || (_cache[203] = _createElementVNode("label", null, "관계", -1)),
                      _createElementVNode("div", _hoisted_141, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (($setup.state.data.clientDetailVO.phoneNameRel) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_142), [
                          [_vModelText, $setup.state.data.clientDetailVO.phoneNameRel]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _cache[209] || (_cache[209] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "집전화")
                  ], -1)),
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", _hoisted_146, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (($setup.state.data.clientDetailVO.tel1) = $event)),
                          onChange: _cache[64] || (_cache[64] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.tel =
                                                        $setup.state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "3"
                        }, null, 40, _hoisted_147), [
                          [_vModelText, $setup.state.data.clientDetailVO.tel1]
                        ])
                      ]),
                      _cache[205] || (_cache[205] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_148, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (($setup.state.data.clientDetailVO.tel2) = $event)),
                          onChange: _cache[66] || (_cache[66] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.tel =
                                                        $setup.state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_149), [
                          [_vModelText, $setup.state.data.clientDetailVO.tel2]
                        ])
                      ]),
                      _cache[206] || (_cache[206] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_150, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (($setup.state.data.clientDetailVO.tel3) = $event)),
                          onChange: _cache[68] || (_cache[68] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.tel =
                                                        $setup.state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.tel3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_151), [
                          [_vModelText, $setup.state.data.clientDetailVO.tel3]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _cache[207] || (_cache[207] = _createElementVNode("label", null, "명의", -1)),
                      _createElementVNode("div", _hoisted_153, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (($setup.state.data.clientDetailVO.telName) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_154), [
                          [_vModelText, $setup.state.data.clientDetailVO.telName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_155, [
                      _cache[208] || (_cache[208] = _createElementVNode("label", null, "관계", -1)),
                      _createElementVNode("div", _hoisted_156, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (($setup.state.data.clientDetailVO.telNameRel) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_157), [
                          [_vModelText, $setup.state.data.clientDetailVO.telNameRel]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _cache[214] || (_cache[214] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "긴급연락처/ 관계")
                  ], -1)),
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (($setup.state.data.clientDetailVO.telEmergency1) = $event)),
                          onChange: _cache[72] || (_cache[72] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.telEmergency =
                                                        $setup.state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "3"
                        }, null, 40, _hoisted_162), [
                          [_vModelText, $setup.state.data.clientDetailVO.telEmergency1]
                        ])
                      ]),
                      _cache[210] || (_cache[210] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_163, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (($setup.state.data.clientDetailVO.telEmergency2) = $event)),
                          onChange: _cache[74] || (_cache[74] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.telEmergency =
                                                        $setup.state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_164), [
                          [_vModelText, $setup.state.data.clientDetailVO.telEmergency2]
                        ])
                      ]),
                      _cache[211] || (_cache[211] = _createElementVNode("span", null, "-", -1)),
                      _createElementVNode("div", _hoisted_165, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (($setup.state.data.clientDetailVO.telEmergency3) = $event)),
                          onChange: _cache[76] || (_cache[76] = ($event: any) => (
                                                    $setup.state.data.clientDetailVO.telEmergency =
                                                        $setup.state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        $setup.state.data.clientDetailVO.telEmergency3
                                                )),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          maxlength: "4"
                        }, null, 40, _hoisted_166), [
                          [_vModelText, $setup.state.data.clientDetailVO.telEmergency3]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_167, [
                      _cache[212] || (_cache[212] = _createElementVNode("label", null, "명의", -1)),
                      _createElementVNode("div", _hoisted_168, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (($setup.state.data.clientDetailVO.telEmergencyName) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_169), [
                          [_vModelText, $setup.state.data.clientDetailVO.telEmergencyName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      _cache[213] || (_cache[213] = _createElementVNode("label", null, "관계", -1)),
                      _createElementVNode("div", _hoisted_171, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (($setup.state.data.clientDetailVO.telEmergencyNameRel) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_172), [
                          [_vModelText, $setup.state.data.clientDetailVO.telEmergencyNameRel]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_173, [
                  _cache[215] || (_cache[215] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "이메일, SNS")
                  ], -1)),
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("div", _hoisted_175, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "텍스트를 입력해주세요",
                        type: "text",
                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (($setup.state.data.clientDetailVO.email) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_176), [
                        [_vModelText, $setup.state.data.clientDetailVO.email]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_177, [
                  _cache[216] || (_cache[216] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "성매매 지역")
                  ], -1)),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("div", _hoisted_180, [
                        _createElementVNode("div", _hoisted_181, [
                          _createElementVNode("div", _hoisted_182, [
                            _withDirectives(_createElementVNode("select", {
                              class: "w150",
                              "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (($setup.state.data.area1) = $event)),
                              onChange: _cache[81] || (_cache[81] = ($event: any) => (
                                                            $setup.state.data.area1 !== '광역시' && $setup.state.data.area1 !== '각 도별'
                                                                ? ($setup.state.data.area = $setup.state.data.area1)
                                                                : ($setup.state.data.area = '')
                                                        )),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.area1List, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.name
                                }, _toDisplayString(item.name), 9, _hoisted_184))
                              }), 256))
                            ], 40, _hoisted_183), [
                              [_vModelSelect, $setup.state.data.area1]
                            ])
                          ]),
                          ($setup.state.data.area1 === '서울' || ($setup.state.data.area1 && $setup.state.data.area1.indexOf('서울') > -1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "w250",
                                  "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (($setup.state.data.area4) = $event)),
                                  onChange: _cache[83] || (_cache[83] = ($event: any) => ($setup.state.data.area = $setup.state.data.area4)),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.area4List, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.name
                                    }, _toDisplayString(item.name), 9, _hoisted_187))
                                  }), 256))
                                ], 40, _hoisted_186), [
                                  [_vModelSelect, $setup.state.data.area4]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (
                                                        $setup.state.data.area1 === '광역시' || ($setup.state.data.area1 && $setup.state.data.area1.indexOf('광역시') > -1)
                                                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "w250",
                                  "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (($setup.state.data.area2) = $event)),
                                  onChange: _cache[85] || (_cache[85] = ($event: any) => ($setup.state.data.area = $setup.state.data.area2)),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.area2List, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.name
                                    }, _toDisplayString(item.name), 9, _hoisted_190))
                                  }), 256))
                                ], 40, _hoisted_189), [
                                  [_vModelSelect, $setup.state.data.area2]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.state.data.area1 === '각 도별' || ($setup.state.data.area1 && $setup.state.data.area1.indexOf('도') > -1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "w250",
                                  "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (($setup.state.data.area3) = $event)),
                                  onChange: _cache[87] || (_cache[87] = ($event: any) => ($setup.state.data.area = $setup.state.data.area3)),
                                  disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.area3List, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.name
                                    }, _toDisplayString(item.name), 9, _hoisted_193))
                                  }), 256))
                                ], 40, _hoisted_192), [
                                  [_vModelSelect, $setup.state.data.area3]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("div", _hoisted_195, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: "기타",
                          "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (($setup.state.data.areaComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_196), [
                          [_vModelText, $setup.state.data.areaComment]
                        ]),
                        _createElementVNode("p", {
                          textContent: _toDisplayString($setup.state.data.areaComment)
                        }, null, 8, _hoisted_197)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_198, [
                  _cache[217] || (_cache[217] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "성매매 유형")
                  ], -1)),
                  _createElementVNode("div", _hoisted_199, [
                    _createElementVNode("div", _hoisted_200, [
                      _createElementVNode("div", _hoisted_201, [
                        _createElementVNode("div", _hoisted_202, [
                          _withDirectives(_createElementVNode("select", {
                            class: "w150",
                            "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => (($setup.state.data.type) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.typeList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_204))
                            }), 256))
                          ], 8, _hoisted_203), [
                            [_vModelSelect, $setup.state.data.type]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_205, [
                      _createElementVNode("div", _hoisted_206, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: "기타",
                          "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (($setup.state.data.typeComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_207), [
                          [_vModelText, $setup.state.data.typeComment]
                        ]),
                        _createElementVNode("p", {
                          textContent: _toDisplayString($setup.state.data.typeComment)
                        }, null, 8, _hoisted_208)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_209, [
                  _cache[218] || (_cache[218] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "선불액수")
                  ], -1)),
                  _createElementVNode("div", _hoisted_210, [
                    _createElementVNode("div", _hoisted_211, [
                      _createElementVNode("div", _hoisted_212, [
                        _createElementVNode("div", _hoisted_213, [
                          _withDirectives(_createElementVNode("select", {
                            class: "w150",
                            "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (($setup.state.data.price) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.priceList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_215))
                            }), 256))
                          ], 8, _hoisted_214), [
                            [_vModelSelect, $setup.state.data.price]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: "기타",
                          "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => (($setup.state.data.priceComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_218), [
                          [_vModelText, $setup.state.data.priceComment]
                        ]),
                        _createElementVNode("p", {
                          textContent: _toDisplayString($setup.state.data.priceComment)
                        }, null, 8, _hoisted_219)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_220, [
                  _cache[219] || (_cache[219] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "알선고리")
                  ], -1)),
                  _createElementVNode("div", _hoisted_221, [
                    _createElementVNode("div", _hoisted_222, [
                      _createElementVNode("div", _hoisted_223, [
                        _createElementVNode("div", _hoisted_224, [
                          _withDirectives(_createElementVNode("select", {
                            class: "w150",
                            "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (($setup.state.data.broker) = $event)),
                            disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.brokerList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_226))
                            }), 256))
                          ], 8, _hoisted_225), [
                            [_vModelSelect, $setup.state.data.broker]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_227, [
                      _createElementVNode("div", _hoisted_228, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: "기타",
                          "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (($setup.state.data.brokerComment) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_229), [
                          [_vModelText, $setup.state.data.brokerComment]
                        ]),
                        _createElementVNode("p", {
                          textContent: _toDisplayString($setup.state.data.brokerComment)
                        }, null, 8, _hoisted_230)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_231, [
                  _cache[223] || (_cache[223] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "유입시기")
                  ], -1)),
                  _createElementVNode("div", _hoisted_232, [
                    _createElementVNode("div", _hoisted_233, [
                      _cache[220] || (_cache[220] = _createElementVNode("label", null, "연도", -1)),
                      _createElementVNode("div", _hoisted_234, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => (($setup.state.data.historyYear) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          class: "year_input"
                        }, null, 8, _hoisted_235), [
                          [_vModelText, $setup.state.data.historyYear]
                        ])
                      ]),
                      _cache[221] || (_cache[221] = _createElementVNode("span", null, "년", -1))
                    ]),
                    _createElementVNode("div", _hoisted_236, [
                      _cache[222] || (_cache[222] = _createElementVNode("span", null, "당시 나이", -1)),
                      _createElementVNode("div", _hoisted_237, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (($setup.state.data.historyAge) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1,
                          class: "old_input"
                        }, null, 8, _hoisted_238), [
                          [_vModelText, $setup.state.data.historyAge]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_239, [
                  _cache[230] || (_cache[230] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "장애진단여부")
                  ], -1)),
                  _createElementVNode("div", _hoisted_240, [
                    _createElementVNode("div", _hoisted_241, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isHuddle",
                          checked: $setup.state.data.isHurdles === '',
                          onClick: _cache[97] || (_cache[97] = ($event: any) => ($setup.state.data.isHurdles = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_242),
                        _cache[224] || (_cache[224] = _createElementVNode("em", null, null, -1)),
                        _cache[225] || (_cache[225] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isHuddle",
                          checked: $setup.state.data.isHurdles === 1,
                          onClick: _cache[98] || (_cache[98] = ($event: any) => ($setup.state.data.isHurdles = 1)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_243),
                        _cache[226] || (_cache[226] = _createElementVNode("em", null, null, -1)),
                        _cache[227] || (_cache[227] = _createElementVNode("span", null, "있음", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isHuddle",
                          checked: $setup.state.data.isHurdles === 0,
                          onClick: _cache[99] || (_cache[99] = ($event: any) => ($setup.state.data.isHurdles = 0)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_244),
                        _cache[228] || (_cache[228] = _createElementVNode("em", null, null, -1)),
                        _cache[229] || (_cache[229] = _createElementVNode("span", null, "없음", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_245, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "기타",
                        "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (($setup.state.data.isHurdlesComment) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_246), [
                        [_vModelText, $setup.state.data.isHurdlesComment]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_247, [
                  _cache[249] || (_cache[249] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "장애유형")
                  ], -1)),
                  _createElementVNode("div", _hoisted_248, [
                    _createElementVNode("div", _hoisted_249, [
                      _createElementVNode("div", _hoisted_250, [
                        _createElementVNode("div", _hoisted_251, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '',
                              onClick: _cache[101] || (_cache[101] = ($event: any) => ($setup.state.data.hurdlesType = '')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_252),
                            _cache[231] || (_cache[231] = _createElementVNode("em", null, null, -1)),
                            _cache[232] || (_cache[232] = _createElementVNode("span", null, "선택안함", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '없음',
                              onClick: _cache[102] || (_cache[102] = ($event: any) => ($setup.state.data.hurdlesType = '없음')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_253),
                            _cache[233] || (_cache[233] = _createElementVNode("em", null, null, -1)),
                            _cache[234] || (_cache[234] = _createElementVNode("span", null, "없음", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_254, [
                      _cache[241] || (_cache[241] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "추정")
                      ], -1)),
                      _createElementVNode("div", _hoisted_255, [
                        _createElementVNode("div", _hoisted_256, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '지적장애(추정)',
                              onClick: _cache[103] || (_cache[103] = ($event: any) => ($setup.state.data.hurdlesType = '지적장애(추정)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_257),
                            _cache[235] || (_cache[235] = _createElementVNode("em", null, null, -1)),
                            _cache[236] || (_cache[236] = _createElementVNode("span", null, "지적장애", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '정신장애(추정)',
                              onClick: _cache[104] || (_cache[104] = ($event: any) => ($setup.state.data.hurdlesType = '정신장애(추정)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_258),
                            _cache[237] || (_cache[237] = _createElementVNode("em", null, null, -1)),
                            _cache[238] || (_cache[238] = _createElementVNode("span", null, "정신장애", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '신체장애(추정)',
                              onClick: _cache[105] || (_cache[105] = ($event: any) => ($setup.state.data.hurdlesType = '신체장애(추정)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_259),
                            _cache[239] || (_cache[239] = _createElementVNode("em", null, null, -1)),
                            _cache[240] || (_cache[240] = _createElementVNode("span", null, "신체장애", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_260, [
                      _cache[248] || (_cache[248] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "등록")
                      ], -1)),
                      _createElementVNode("div", _hoisted_261, [
                        _createElementVNode("div", _hoisted_262, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '지적장애(등록)',
                              onClick: _cache[106] || (_cache[106] = ($event: any) => ($setup.state.data.hurdlesType = '지적장애(등록)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_263),
                            _cache[242] || (_cache[242] = _createElementVNode("em", null, null, -1)),
                            _cache[243] || (_cache[243] = _createElementVNode("span", null, "지적장애", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '정신장애(등록)',
                              onClick: _cache[107] || (_cache[107] = ($event: any) => ($setup.state.data.hurdlesType = '정신장애(등록)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_264),
                            _cache[244] || (_cache[244] = _createElementVNode("em", null, null, -1)),
                            _cache[245] || (_cache[245] = _createElementVNode("span", null, "정신장애", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "hurdlesType",
                              checked: $setup.state.data.hurdlesType === '신체장애(등록)',
                              onClick: _cache[108] || (_cache[108] = ($event: any) => ($setup.state.data.hurdlesType = '신체장애(등록)')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_265),
                            _cache[246] || (_cache[246] = _createElementVNode("em", null, null, -1)),
                            _cache[247] || (_cache[247] = _createElementVNode("span", null, "신체장애", -1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_266, [
                  _cache[256] || (_cache[256] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "수급유형")
                  ], -1)),
                  _createElementVNode("div", _hoisted_267, [
                    _createElementVNode("div", _hoisted_268, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "hurdlesReceive",
                          checked: $setup.state.data.hurdlesReceive === '',
                          onClick: _cache[109] || (_cache[109] = ($event: any) => ($setup.state.data.hurdlesReceive = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_269),
                        _cache[250] || (_cache[250] = _createElementVNode("em", null, null, -1)),
                        _cache[251] || (_cache[251] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "hurdlesReceive",
                          checked: $setup.state.data.hurdlesReceive === '수급자',
                          onClick: _cache[110] || (_cache[110] = ($event: any) => ($setup.state.data.hurdlesReceive = '수급자')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_270),
                        _cache[252] || (_cache[252] = _createElementVNode("em", null, null, -1)),
                        _cache[253] || (_cache[253] = _createElementVNode("span", null, "수급자", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "hurdlesReceive",
                          checked: $setup.state.data.hurdlesReceive === '일반',
                          onClick: _cache[111] || (_cache[111] = ($event: any) => ($setup.state.data.hurdlesReceive = '일반')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_271),
                        _cache[254] || (_cache[254] = _createElementVNode("em", null, null, -1)),
                        _cache[255] || (_cache[255] = _createElementVNode("span", null, "일반", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_272, [
                  _cache[257] || (_cache[257] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "학력")
                  ], -1)),
                  _createElementVNode("div", _hoisted_273, [
                    _createElementVNode("div", _hoisted_274, [
                      _createElementVNode("div", _hoisted_275, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => (($setup.state.data.clientDetailVO.historySchool) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.schoolHistoryList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.key
                            }, _toDisplayString(item.name), 9, _hoisted_277))
                          }), 256))
                        ], 8, _hoisted_276), [
                          [_vModelSelect, $setup.state.data.clientDetailVO.historySchool]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_278, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "historySchoolDesc",
                          "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => (($setup.state.data.clientDetailVO.historySchoolDesc) = $event)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_279), [
                          [_vModelText, $setup.state.data.clientDetailVO.historySchoolDesc]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_280, [
                  _cache[264] || (_cache[264] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "가출경험유무")
                  ], -1)),
                  _createElementVNode("div", _hoisted_281, [
                    _createElementVNode("div", _hoisted_282, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isRunaway",
                          checked: $setup.state.data.isRunaway === '',
                          onClick: _cache[114] || (_cache[114] = ($event: any) => ($setup.state.data.isRunaway = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_283),
                        _cache[258] || (_cache[258] = _createElementVNode("em", null, null, -1)),
                        _cache[259] || (_cache[259] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isRunaway",
                          checked: $setup.state.data.isRunaway === '있음',
                          onClick: _cache[115] || (_cache[115] = ($event: any) => ($setup.state.data.isRunaway = '있음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_284),
                        _cache[260] || (_cache[260] = _createElementVNode("em", null, null, -1)),
                        _cache[261] || (_cache[261] = _createElementVNode("span", null, "있음", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isRunaway",
                          checked: $setup.state.data.isRunaway === '없음',
                          onClick: _cache[116] || (_cache[116] = ($event: any) => ($setup.state.data.isRunaway = '없음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_285),
                        _cache[262] || (_cache[262] = _createElementVNode("em", null, null, -1)),
                        _cache[263] || (_cache[263] = _createElementVNode("span", null, "없음", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_286, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "기타",
                        name: "isRunawayComment",
                        "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => (($setup.state.data.isRunawayComment) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_287), [
                        [_vModelText, $setup.state.data.isRunawayComment]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_288, [
                  _cache[280] || (_cache[280] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "처음 가출한 시기")
                  ], -1)),
                  _createElementVNode("div", _hoisted_289, [
                    _createElementVNode("div", _hoisted_290, [
                      _cache[275] || (_cache[275] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "학교")
                      ], -1)),
                      _createElementVNode("div", _hoisted_291, [
                        _createElementVNode("div", _hoisted_292, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "historySchool",
                              checked: $setup.state.data.firstRunawayDate === '',
                              onClick: _cache[118] || (_cache[118] = ($event: any) => ($setup.state.data.firstRunawayDate = '')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_293),
                            _cache[265] || (_cache[265] = _createElementVNode("em", null, null, -1)),
                            _cache[266] || (_cache[266] = _createElementVNode("span", null, "선택안함", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "historySchool",
                              checked: $setup.state.data.firstRunawayDate === '초등학교',
                              onClick: _cache[119] || (_cache[119] = ($event: any) => ($setup.state.data.firstRunawayDate = '초등학교')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_294),
                            _cache[267] || (_cache[267] = _createElementVNode("em", null, null, -1)),
                            _cache[268] || (_cache[268] = _createElementVNode("span", null, "초등학교", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "historySchool",
                              checked: $setup.state.data.firstRunawayDate === '중학교',
                              onClick: _cache[120] || (_cache[120] = ($event: any) => ($setup.state.data.firstRunawayDate = '중학교')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_295),
                            _cache[269] || (_cache[269] = _createElementVNode("em", null, null, -1)),
                            _cache[270] || (_cache[270] = _createElementVNode("span", null, "중학교", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "historySchool",
                              checked: $setup.state.data.firstRunawayDate === '고등학교',
                              onClick: _cache[121] || (_cache[121] = ($event: any) => ($setup.state.data.firstRunawayDate = '고등학교')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_296),
                            _cache[271] || (_cache[271] = _createElementVNode("em", null, null, -1)),
                            _cache[272] || (_cache[272] = _createElementVNode("span", null, "고등학교", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "historySchool",
                              checked: $setup.state.data.firstRunawayDate === '성인',
                              onClick: _cache[122] || (_cache[122] = ($event: any) => ($setup.state.data.firstRunawayDate = '성인')),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_297),
                            _cache[273] || (_cache[273] = _createElementVNode("em", null, null, -1)),
                            _cache[274] || (_cache[274] = _createElementVNode("span", null, "성인", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_298, [
                      _cache[279] || (_cache[279] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "가출한 나이")
                      ], -1)),
                      _createElementVNode("div", _hoisted_299, [
                        _createElementVNode("div", _hoisted_300, [
                          _createElementVNode("div", _hoisted_301, [
                            _withDirectives(_createElementVNode("input", {
                              class: "old_input",
                              type: "text",
                              "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => (($setup.state.data.runawayAge) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_302), [
                              [_vModelText, $setup.state.data.runawayAge]
                            ])
                          ]),
                          _cache[276] || (_cache[276] = _createElementVNode("span", null, "세", -1))
                        ]),
                        _createElementVNode("div", _hoisted_303, [
                          _createElementVNode("div", _hoisted_304, [
                            _cache[277] || (_cache[277] = _createElementVNode("span", null, "연도", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "year_input",
                              type: "text",
                              "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => (($setup.state.data.runawayYear) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_305), [
                              [_vModelText, $setup.state.data.runawayYear]
                            ])
                          ]),
                          _cache[278] || (_cache[278] = _createElementVNode("span", null, "년", -1))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_306, [
                  _cache[288] || (_cache[288] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "성폭력 유무")
                  ], -1)),
                  _createElementVNode("div", _hoisted_307, [
                    _createElementVNode("div", _hoisted_308, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isSexualViolence",
                          checked: $setup.state.data.isSexualViolence === '',
                          onClick: _cache[125] || (_cache[125] = ($event: any) => ($setup.state.data.isSexualViolence = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_309),
                        _cache[281] || (_cache[281] = _createElementVNode("em", null, null, -1)),
                        _cache[282] || (_cache[282] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isSexualViolence",
                          checked: $setup.state.data.isSexualViolence === '있음',
                          onClick: _cache[126] || (_cache[126] = ($event: any) => ($setup.state.data.isSexualViolence = '있음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_310),
                        _cache[283] || (_cache[283] = _createElementVNode("em", null, null, -1)),
                        _cache[284] || (_cache[284] = _createElementVNode("span", null, "있음", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isSexualViolence",
                          checked: $setup.state.data.isSexualViolence === '없음',
                          onClick: _cache[127] || (_cache[127] = ($event: any) => ($setup.state.data.isSexualViolence = '없음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_311),
                        _cache[285] || (_cache[285] = _createElementVNode("em", null, null, -1)),
                        _cache[286] || (_cache[286] = _createElementVNode("span", null, "없음", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_312, [
                      _cache[287] || (_cache[287] = _createElementVNode("span", null, "횟수", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "cntSexualViolence",
                        "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => (($setup.state.data.cntSexualViolence) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_313), [
                        [_vModelText, $setup.state.data.cntSexualViolence]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_314, [
                  _cache[301] || (_cache[301] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "혼인 여부")
                  ], -1)),
                  _createElementVNode("div", _hoisted_315, [
                    _createElementVNode("div", _hoisted_316, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === null,
                          onClick: _cache[129] || (_cache[129] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = null)),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_317),
                        _cache[289] || (_cache[289] = _createElementVNode("em", null, null, -1)),
                        _cache[290] || (_cache[290] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === '3',
                          onClick: _cache[130] || (_cache[130] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = '3')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_318),
                        _cache[291] || (_cache[291] = _createElementVNode("em", null, null, -1)),
                        _cache[292] || (_cache[292] = _createElementVNode("span", null, "미혼", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === '2',
                          onClick: _cache[131] || (_cache[131] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = '2')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_319),
                        _cache[293] || (_cache[293] = _createElementVNode("em", null, null, -1)),
                        _cache[294] || (_cache[294] = _createElementVNode("span", null, "동거", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === '4',
                          onClick: _cache[132] || (_cache[132] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = '4')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_320),
                        _cache[295] || (_cache[295] = _createElementVNode("em", null, null, -1)),
                        _cache[296] || (_cache[296] = _createElementVNode("span", null, "이혼", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === '5',
                          onClick: _cache[133] || (_cache[133] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = '5')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_321),
                        _cache[297] || (_cache[297] = _createElementVNode("em", null, null, -1)),
                        _cache[298] || (_cache[298] = _createElementVNode("span", null, "혼인중", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "marriageType",
                          checked: $setup.state.data.clientDetailVO.marriageType === '1',
                          onClick: _cache[134] || (_cache[134] = ($event: any) => ($setup.state.data.clientDetailVO.marriageType = '1')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_322),
                        _cache[299] || (_cache[299] = _createElementVNode("em", null, null, -1)),
                        _cache[300] || (_cache[300] = _createElementVNode("span", null, "기타", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_323, [
                  _cache[308] || (_cache[308] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "가정폭력 유무")
                  ], -1)),
                  _createElementVNode("div", _hoisted_324, [
                    _createElementVNode("div", _hoisted_325, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isViolence",
                          checked: $setup.state.data.isViolence === '',
                          onClick: _cache[135] || (_cache[135] = ($event: any) => ($setup.state.data.isViolence = '')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_326),
                        _cache[302] || (_cache[302] = _createElementVNode("em", null, null, -1)),
                        _cache[303] || (_cache[303] = _createElementVNode("span", null, "선택안함", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isViolence",
                          checked: $setup.state.data.isViolence === '있음',
                          onClick: _cache[136] || (_cache[136] = ($event: any) => ($setup.state.data.isViolence = '있음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_327),
                        _cache[304] || (_cache[304] = _createElementVNode("em", null, null, -1)),
                        _cache[305] || (_cache[305] = _createElementVNode("span", null, "있음", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "isViolence",
                          checked: $setup.state.data.isViolence === '없음',
                          onClick: _cache[137] || (_cache[137] = ($event: any) => ($setup.state.data.isViolence = '없음')),
                          disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                        }, null, 8, _hoisted_328),
                        _cache[306] || (_cache[306] = _createElementVNode("em", null, null, -1)),
                        _cache[307] || (_cache[307] = _createElementVNode("span", null, "없음", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_329, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "기타",
                        name: "isViolenceComment",
                        "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => (($setup.state.data.isViolenceComment) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_330), [
                        [_vModelText, $setup.state.data.isViolenceComment]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_331, [
                  _cache[309] || (_cache[309] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "가족관계")
                  ], -1)),
                  _createElementVNode("div", _hoisted_332, [
                    _createElementVNode("div", _hoisted_333, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "텍스트를 입력해주세요",
                        type: "text",
                        name: "family",
                        "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => (($setup.state.data.family) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_334), [
                        [_vModelText, $setup.state.data.family]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_335, [
                  _cache[310] || (_cache[310] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "자녀 여부")
                  ], -1)),
                  _createElementVNode("div", _hoisted_336, [
                    _createElementVNode("div", _hoisted_337, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "텍스트를 입력해주세요",
                        type: "text",
                        name: "hasChild",
                        "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => (($setup.state.data.clientDetailVO.hasChild) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_338), [
                        [_vModelText, $setup.state.data.clientDetailVO.hasChild]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_339, [
                  _cache[311] || (_cache[311] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, [
                      _createTextVNode(" 성매매 유입 "),
                      _createElementVNode("br"),
                      _createTextVNode(" 및 이동경로 ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_340, [
                    _createElementVNode("div", _hoisted_341, [
                      _withDirectives(_createElementVNode("textarea", {
                        placeholder: "- 성매매 종사시기\r\n- 유입에서 현재에 이르기까지의 종사유형, 업소경유 구체적으로\r\n- 마지막 업소 일한 현황 및 업소 나오게 된 경위",
                        "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => (($setup.state.data.sexualViolenceLocation) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_342), [
                        [_vModelText, $setup.state.data.sexualViolenceLocation]
                      ]),
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.data.sexualViolenceLocation)
                      }, null, 8, _hoisted_343)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_344, [
                  _cache[318] || (_cache[318] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "상담 내용")
                  ], -1)),
                  _createElementVNode("div", _hoisted_345, [
                    _createElementVNode("div", _hoisted_346, [
                      _createElementVNode("div", _hoisted_347, [
                        _cache[312] || (_cache[312] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, [
                            _createTextVNode(" 성매매관련 피해 "),
                            _createElementVNode("p", null, "(업소/ 소개소/ 사채/ 맞보증/ 보험/ 계/ 굿/ 성형 등 연결 현황)")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_348, [
                          _createElementVNode("div", _hoisted_349, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "텍스트를 입력해 주세요.",
                              "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => (($setup.state.data.sexualViolenceVictims) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_350), [
                              [_vModelText, $setup.state.data.sexualViolenceVictims]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.sexualViolenceVictims)
                            }, null, 8, _hoisted_351)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_352, [
                        _cache[313] || (_cache[313] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, [
                            _createTextVNode(" 관련 사건체크 "),
                            _createElementVNode("p", null, "(지원받은 경력)"),
                            _createTextVNode(" 현재 집형 사건 "),
                            _createElementVNode("p", null, "(전과기록 등)")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_353, [
                          _createElementVNode("div", _hoisted_354, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "텍스트를 입력해 주세요.",
                              "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event: any) => (($setup.state.data.sexualViolenceCase) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_355), [
                              [_vModelText, $setup.state.data.sexualViolenceCase]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.sexualViolenceCase)
                            }, null, 8, _hoisted_356)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_357, [
                        _cache[314] || (_cache[314] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, [
                            _createTextVNode(" 신변안전상태 "),
                            _createElementVNode("p", null, "(위협/ 협박 등)")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_358, [
                          _createElementVNode("div", _hoisted_359, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "텍스트를 입력해 주세요.",
                              "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => (($setup.state.data.safetyStatus) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_360), [
                              [_vModelText, $setup.state.data.safetyStatus]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.safetyStatus)
                            }, null, 8, _hoisted_361)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_362, [
                        _cache[315] || (_cache[315] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, "법률지원")
                        ], -1)),
                        _createElementVNode("div", _hoisted_363, [
                          _createElementVNode("div", _hoisted_364, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "- 법원/ 사건번호:\r\n- 검/ 경 담당부서, 담당자:.",
                              "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => (($setup.state.data.supportLegal) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_365), [
                              [_vModelText, $setup.state.data.supportLegal]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.supportLegal)
                            }, null, 8, _hoisted_366)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_367, [
                        _cache[316] || (_cache[316] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, "의료지원")
                        ], -1)),
                        _createElementVNode("div", _hoisted_368, [
                          _createElementVNode("div", _hoisted_369, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "- 건강상태:\r\n- 장애진단:\r\n- 약물복용:\r\n- 자살시도:\r\n- 정신건강:",
                              "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => (($setup.state.data.supportMedical) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_370), [
                              [_vModelText, $setup.state.data.supportMedical]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.supportMedical)
                            }, null, 8, _hoisted_371)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_372, [
                        _cache[317] || (_cache[317] = _createElementVNode("div", { class: "area_col_head w150" }, [
                          _createElementVNode("label", null, "자활지원")
                        ], -1)),
                        _createElementVNode("div", _hoisted_373, [
                          _createElementVNode("div", _hoisted_374, [
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "텍스트를 입력해 주세요.",
                              "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => (($setup.state.data.supportSelfReliance) = $event)),
                              disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                            }, null, 8, _hoisted_375), [
                              [_vModelText, $setup.state.data.supportSelfReliance]
                            ]),
                            _createElementVNode("p", {
                              textContent: _toDisplayString($setup.state.data.supportSelfReliance)
                            }, null, 8, _hoisted_376)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_377, [
                  _cache[319] || (_cache[319] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "면접자 의견")
                  ], -1)),
                  _createElementVNode("div", _hoisted_378, [
                    _createElementVNode("div", _hoisted_379, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "comment",
                        "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => (($setup.state.data.comment) = $event)),
                        disabled: $setup.state.mode === false && $setup.state.hasAuth !== 1
                      }, null, 8, _hoisted_380), [
                        [_vModelText, $setup.state.data.comment]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          gubun: $setup.state.gubun,
          path: $setup.state.path,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "gubun", "path", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}